import { ACTIVE_NETWORK } from './network';

// ============================================================
// CONTRACT ADDRESSES
// ============================================================
// Update these after deploying your contracts to each network.
//
//   mainnet  = opBNB Mainnet (chainId 204)
//   testnet  = opBNB Testnet (chainId 5611)
//
// ============================================================

const ADDRESSES = {
  // opBNB Mainnet — paste addresses after deploying to opBNB mainnet
  mainnet: {
    GlobalLogic: '0x340A8eb7af0661746E0b0908D7Fc8Cd570850466',
    GlobalStorage: '0x357f87aF298EB23bAC3F4031c752b67C00FF7B1B',
    // opBNB Mainnet USDT (BEP-20, 18 decimals) — verify the correct token address
    USDT: '0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3'
  },
  // opBNB Testnet
  testnet: {
    GlobalLogic: '0xF5dC2eC8aC1a7C8116B05D66348ae66c596eB755',
    GlobalStorage: '0x7Bfd97f49DE2A93763fAf56CB9a650D4913F380d',
    // Deploy your test USDT and paste address here
    USDT: '0xBf6596a279172D330b8b732D257Ee633B6FDA911'
  }
};

export const CONTRACTS = ADDRESSES[ACTIVE_NETWORK];

// Package prices (in USDT, human-readable)
export const PACKAGE_PRICES = [5, 10, 20, 40, 80, 160, 320, 640, 1280, 2560, 5120, 10240];

export const TOTAL_PACKAGES = 12;
export const MATRIX_LEVELS = 15;
export const DEFAULT_REFERRER_ID = 100000;
